import * as React from 'react';
import * as styles from './styles.css';

import { Banner } from '@cian/frontend-val-my-home-banner';

export const BannerWrapper = () => {
  return (
    <div className={styles['container']}>
      <Banner />
    </div>
  );
};
